import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Auth } from '@common/Auth'
import { PRIVILEGE_STORE_ID } from '@constant'
import Item from '../../Common/Tag/Item'
import { Flex } from 'hljd'

@Auth({ role: [PRIVILEGE_STORE_ID] })
@inject('decorationStore')
@observer
export default class extends Component {
  componentDidMount() {
    this.props.decorationStore.getMealCaseProperty({
      commodity_type: 1
    })
  }

  render() {
    const {
      casePropertyList,
      currentCaseProperty,
      changeCaseProperty
    } = this.props.decorationStore

    return (
      <Flex wrap>
        {casePropertyList.map(item => (
          <Item
            key={item.id}
            {...item}
            active={currentCaseProperty}
            onChange={changeCaseProperty}
          />
        ))}
      </Flex>
    )
  }
}
